<script setup lang="ts">
/** FE-014 — redesign shell; the copy is unchanged. */
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="fair-auth-status">
    <h2 class="fair-auth-status__title">
      {{ t("reset_password.password_changed_success") }}
    </h2>
  </div>
</template>
